import React from 'react';
import { Typography } from '@mui/material';

const ParaTitle = (props) => {
    var {content } = props;
    return (
        <Typography align='left' sx={{ fontSize: "20px", fontWeight: "bold", marginTop: "20px" }}>{content}</Typography>
    )
}

export default ParaTitle;